/** Compact list context: object rows as a pipe-delimited table (column names once), string rows newline-joined. */
export function formatCompactList(items: Array<string | Record<string, unknown>>): string {
  if (!items.length) return '';

  // string rows: caller already compacted them, just stack the lines
  if (items.every((item) => typeof item !== 'object' || item === null)) {
    return items.map((item) => sanitizeCell(String(item ?? ''))).join('\n');
  }

  // object rows: build the column union in first-seen order
  const columns: string[] = [];
  for (const item of items) {
    if (item && typeof item === 'object') {
      for (const key of Object.keys(item)) {
        if (!columns.includes(key)) columns.push(key);
      }
    }
  }

  const lines = [columns.join(' | ')];
  for (const item of items) {
    const row = item as Record<string, unknown> | string | null;
    const cells = columns.map((col) =>
      row && typeof row === 'object' ? formatCellValue((row as Record<string, unknown>)[col]) : ''
    );
    lines.push(cells.join(' | '));
  }
  return lines.join('\n');
}

function formatCellValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return sanitizeCell(JSON.stringify(value));
  return sanitizeCell(String(value));
}

// keep values on a single line and prevent them from breaking the pipe-delimited column structure
function sanitizeCell(value: string): string {
  return value
    .replace(/\s*\n\s*/g, ' ')
    .replace(/\|/g, '/')
    .trim();
}
